export enum UserTitle {
  DR = 'DR',
  MR = 'MR',
  MRS = 'MRS',
  MS = 'MS',
  PROF = 'PROF',
}
